import React, { useState, useEffect, useRef } from 'react';
import { useConversation } from '@11labs/react';
import '../PopupVega.css';

const PopupVega = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [conversationStarted, setConversationStarted] = useState(false);
  const [conversationEnded, setConversationEnded] = useState(true);
  const [conversationTime, setConversationTime] = useState(0); // ⏳ Stato per il timer della conversazione
  const timerRef = useRef(null); 

  const { startSession, endSession, status, isSpeaking } = useConversation({
    onConnect: () => {
      console.log('✅ Connessione stabilita');
      
    },
    onDisconnect: () => {
      console.log('❌ Connessione terminata');
     
    },
    onMessage: (message) => {
      console.log('📩 Nuovo messaggio ricevuto:', message);
    },
    onError: (error) => {
      console.error('❌ Errore nella conversazione:', error);
    },
  });

  useEffect(() => {
    console.log("🔄 Reset dello stato dopo il refresh");
    
  }, []);

  useEffect(() => {
    const handleMessage = async (event) => {
      console.log("📩 Messaggio ricevuto da:", event.origin, event.data);

      if (event.origin !== "https://deepagent.app" && event.origin !== "https://www.deepagent.app") {
        console.warn("⚠ Origine non autorizzata:", event.origin);
        return;
      }

      if (event.data.action === "start") {
        console.log("▶ Ricevuto comando START");
        startConversationTimer();

       
          try {
            console.log("🔄 Tentativo di avvio sessione...");
            await startSession({
              agentId: 'o9UXoZ4r3y3dbbfhRkp5',
              timeout: 60000,
            });
          } catch (error) {
            console.error("❌ Errore nell'avvio della conversazione:", error);
            setConversationStarted(false);
          }
        
      }

      if (event.data.action === "stop") {
        console.log("⏹ Ricevuto comando STOP");
        handleEndConversation();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);


  // 🔥 Funzione per avviare il timer della conversazione
  const startConversationTimer = () => {
    setConversationTime(0);
    if (timerRef.current) clearInterval(timerRef.current); // 🔄 Evita timer doppi
    timerRef.current = setInterval(() => {
      setConversationTime((prevTime) => prevTime + 1);
    }, 1000);
  };

  // 🔴 Funzione per fermare il timer della conversazione
  const stopConversationTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };



  const handleEndConversation = async () => {
        try {
            await endSession();
            console.log('🔴 Conversazione terminata');
        } catch (error) {
            console.error('❌ Errore nella terminazione della conversazione:', error);
        }

        stopConversationTimer();

    if (window.parent) {
      console.log("📤 Inviando messaggio di fine conversazione a WordPress...");
      window.parent.postMessage({ action: "conversationEnded" }, "*");
  }
};


const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};


  return (
    
      <div className={`modal-content ${isSpeaking ? '' : 'overlay'}`}>
        <div className="conversation-timer">{formatTime(conversationTime)}</div>
        <video id="modalVideo" autoPlay loop muted playsInline>
          <source src="https://www.deepagent.app/video/VEGA.mp4" type="video/mp4" />
        </video>
        
          <div className="label-video">
            <button id="stopVega" onClick={handleEndConversation}>
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="40" cy="40" r="38.5" stroke="white" strokeWidth="3" />
                    <path
                      d="M19.3946 33.7354C19.529 33.601 19.6693 33.4726 19.8157 33.3382C21.5834 31.7974 23.7243 30.6299 26.7669 29.5459C32.1953 27.6824 37.8595 26.9924 43.6192 27.4908C48.2353 27.9027 52.3409 28.9326 55.8223 30.5567C57.56 31.3688 59.5396 32.4407 61.0862 34.2679C62.1014 35.3786 62.6268 36.8118 62.573 38.3764L62.5758 42.482C62.5757 44.8886 60.9334 46.5428 58.4879 46.5937C57.7475 46.6236 56.9831 46.6117 56.2456 46.6028C55.8783 46.5998 55.5081 46.5938 55.1318 46.5938L51.8832 46.594C49.3393 46.5404 47.7419 44.943 47.6883 42.4229C47.6883 41.7063 47.7003 41.0196 47.7093 40.3358C47.7183 39.7536 47.7272 39.1713 47.7273 38.5861C46.5807 38.1442 45.2699 37.8666 43.5262 37.6935C39.8864 37.3384 36.8558 37.4848 33.9923 38.1568L33.9296 38.1717C33.5534 38.2374 33.1473 38.3748 32.7173 38.5181C32.6009 38.5569 32.4814 38.5987 32.362 38.6346L32.3618 42.4804C32.3618 43.6687 31.9646 44.6929 31.2121 45.4454C30.4597 46.1979 29.4355 46.595 28.2471 46.5951L21.5887 46.5954C19.1044 46.5955 17.4354 44.9265 17.4354 42.4422Z"
                      fill="white"
                    />
                  </svg>
            </button>
          </div>
        
      </div>
    )

};

export default PopupVega;
